/**
 * Solid fills for mobile/PWA status bar (theme-color + iOS safe-area strip).
 * Keep in sync with the topmost visible background of each route — see usePageStatusBar.
 *
 * New screens: call usePageStatusBar at the top of the page (or layout) with the hex that
 * matches the first paint under the status bar. If the route shows LoadingSpinner fullScreen,
 * use `loading ? PAGE_CHROME_LOADER_BRAND_GREEN : yourPageTopColor` so the bar stays correct.
 * WorkoutDetailsPage is an exception (custom scroll/hero chrome in-file).
 */
export const PAGE_CHROME_LOADER_BRAND_GREEN = '#B3E783';
/** Body / marketing shell, white nav bars, exercise detail, login status strip */
export const PAGE_CHROME_LIGHT = '#ffffff';
/** theme.off-white, cream-50, chat, notifications, account */
export const PAGE_CHROME_OFF_WHITE = '#fafafa';
/** Tailwind gray-50 (sprint board, etc.) */
export const PAGE_CHROME_GRAY_50 = '#f9fafb';
/** Trainer Members / Library page canvas (Members list, Library hub, detail/plan routes) */
export const TRAINER_PAGE_BG = '#f4f4f5';
